import { useState, useEffect, useMemo, useContext } from 'react';
// import { callautopopulate } from '../../../services/callautopop';
import services from '../../../services/services';
import { Urls } from '../../../services/Urls';
import { ToastContext } from '../../../context/ToastContext';
import { dateConvert } from "../../../utils/Helper.js";


export const useImport = () => {
    const { showSuccess, showInfo, showError, } = useContext(ToastContext);
    let syncStatus = [];
    const [loader, setloader] = useState(false);
    const [columnDefs] = useState([
        { field: 'sync_type_name', headerName: 'Sync Type', width: '250px', className: 'text-left', },
        { field: 'last_datetime', headerName: 'Last Synced ', width: '250px', className: 'text-left', }
    ])
    const [syncColumn, setSyncColumn] = useState([
        { field: 'serial_no', headerName: 'No.', width: "30%", minWidth: 70, suppressHeaderMenuButton: true, cellStyle: { textAlign: "center" } },
        {
            field: 'error_log_datetime', headerName: 'Time', width: "30%", minWidth: 160, suppressHeaderMenuButton: true,cellStyle: { textAlign: "center" } ,
            cellRenderer: function (params) {
                const formatDate = dateConvert(params?.data?.error_log_datetime, "date-time-month")
                return (
                    <div>{formatDate}</div>
                )
            }
        },
        { field: 'error_info', headerName: 'Message', width: "30%", minWidth: 500,cellStyle: { textAlign: "center" } , suppressHeaderMenuButton: true,     tooltipField: "error_info",
}
    ])

    const [rowData, setRowData] = useState([])
    const [showPopUp, setShowPopUp] = useState(false)
    const [importStatusInfo, setImportStatusInfo] = useState([])



    useEffect(() => {
        getImportStatus()
        // callautopopulate("sync_status").then(res => {
        //     syncStatus = res?.sync_status;
        //     getSyncStatus()
        // });
    }, []);

    const rowClassRules = useMemo(() => {
        return {

            "import-status-time-warning": (params) => {
                return params.data.is_delayed > 0
            },
        };
    }, []);


    const getSyncStatus = () => {
        let syncData = []
        syncStatus.map(sync => {
            const date = new Date(sync.last_datetime)
            let obj = {
                "sync_type_name": sync.sync_type_name,
                "last_datetime": new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                }).format(date),
                "is_delayed": sync.is_delayed
            }
            syncData.push(obj)
        })
        setloader(false)
        setRowData(syncData)
    }

    const getImportStatus = async () => {
       setloader(true)
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETIMPORTSTATUSINFO"));
            if (res?.body?.data?.import_status_info) {
                setImportStatusInfo(res?.body?.data?.import_status_info)
                   setloader(false)

            }
        } catch (error) {
            setloader(false)
            showError("Error", error?.response?.data?.errorMessage);
            console.error("Error retriving import status info", error);
        }
    }

    const handleErrors = async (event) => {
        if (!!event?.error_count) {
            setShowPopUp(true)
            const payload = {
                "config_key": event?.config_key
            }
            try {
                const res = await services.getInvokeRemote("POST", Urls("GETIMPORTSTATUSDETAILS"), payload);
                if (res?.body?.data?.import_status_details) {
                    setRowData(res?.body?.data?.import_status_details)
                }
            } catch (error) {
                showError("Error", error?.response?.data?.errorMessage);
                console.error("Error retriving import status info", error);
            }
        }

    }

    return useMemo(() => ({ columnDefs, rowData, rowClassRules, loader, syncColumn, setSyncColumn, showPopUp, handleErrors, setShowPopUp, importStatusInfo }), [columnDefs, rowData, rowClassRules, loader, handleErrors, syncColumn, setSyncColumn, showPopUp, setShowPopUp, importStatusInfo])
}